module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _c('title', [_vm._v("Daily Light: Morning & Evening")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "page4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1a#cc5",
      "id": "dd5"
    }
  }, [_c('span', {
    attrs: {
      "id": "page_p0008-03-2_11_january"
    }
  }, [_c('i', [_vm._v("January")])]), _vm._v(" 3")])]), _vm._v(" "), _c('p', {
    staticClass: "txl1",
    attrs: {
      "id": "amJanuary3"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORNING")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0008-03-2"
    }
  }, [_c('span', [_c('i', [_vm._v("He led them forth by the right way")]), _vm._v(". ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0008-04-3"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("I")]), _vm._v("n the wasteland, a howling wilderness; He encircled [Jacob], He instructed him, He kept him as the apple of His eye. As an eagle stirs up its nest, hovers over its young, spreading out its wings, taking them up, carrying them on its wings, so the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" alone led him. • Even to your old age, I am He, and even to gray hairs I will carry you! I have made, and I will bear; even I will carry, and will deliver you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0008-05-6"
    }
  }, [_vm._v("He restores my soul; He leads me in the paths of righteousness for His name’s sake. Yea, though I walk through the valley of the shadow of death, I will fear no evil; for You are with me; Your rod and Your staff, they comfort me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0008-05-7"
    }
  }, [_vm._v("The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" will guide you continually, and satisfy your soul in drought, and strengthen your bones; you shall be like a watered garden, and like a spring of water, whose waters do not fail. • For this is God, our God forever and ever; He will be our guide even to death. • Who teaches like Him?")]), _vm._v(" "), _c('p', {
    staticClass: "txc1"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(". 107:7; D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EUT")]), _vm._v(". 32:10–12; I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SA")]), _vm._v(". 46:4; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(". 23:3–4; I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SA")]), _vm._v(". 58:11; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(". 48:14; J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OB")]), _vm._v(" 36:22")]), _vm._v(" "), _c('p', {
    staticClass: "txl1",
    attrs: {
      "id": "aeJanuary3"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VENING")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0008-08-11"
    }
  }, [_c('span', [_c('i', [_vm._v("“What do you want Me to do for you?” He said, “Lord, that I may receive my sight.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0008-09-14"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("O")]), _vm._v("pen my eyes, that I may see wondrous things from Your law.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0008-10-17"
    }
  }, [_vm._v("And He opened their understanding, that they might comprehend the Scriptures. • But the Helper, the Holy Spirit, whom the Father will send in My name, He will teach you all things, and bring to your remembrance all things that I said to you. • Every good gift and every perfect gift is from above, and comes down from the Father of lights, with whom there is no variation or shadow of turning.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0008-11-19"
    }
  }, [_vm._v("God of our Lord Jesus Christ, the Father of glory . . . give to you the spirit of wisdom and revelation in the knowledge of Him, the eyes of your understanding being enlightened; that you may know what is the hope of His calling, what are the riches of the glory of His inheritance in the saints, and what is the exceeding greatness of His power toward us who believe, according to the working of His mighty power.")]), _vm._v(" "), _c('p', {
    staticClass: "txc1"
  }, [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UKE")]), _vm._v(" 18:41; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(". 119:18; L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UKE")]), _vm._v(" 24:45; J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" 14:26; J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(" 1:17; E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PH")]), _vm._v(". 1:17–19")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-371142dd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter5.vue
// module id = 78
// module chunks = 0